<div class="top-section">
    <h6 class="heading mb-0">{{
        ss.t('listKebabMenu_titleTopBar') }}</h6>
    <app-svg name="close" role="button" (click)="closeDialog()"></app-svg>
</div>
<div class="body-section position-relative ri-w-full">
    <div class="list-items-block ri-w-full">
        <div class="category-item ri-px-4 ri-py-4 ri-w-full">
            <div class="flex justify-between ri-w-full">
                <button class="outline-none" (click)="$event.stopPropagation();">
                    <div class="ri-me-6">
                        <span class="text-14-400 color-8 flex">{{ ss.t('common_groupBy') }}</span>
                        <app-input-dropdown
                            [ngClass]="{'!hidden' : listGroupBy() === 'none'}"
                            class="ri-pt-6px" [multiple]="true"
                            [signal]="listGroupedViewType"
                            [config]="vs.groupedViewTypeConfig()" (select)="ss.updateView()"
                            textClass="text-16-400"></app-input-dropdown>
                    </div>
                </button>
                <app-input-dropdown [signal]="listGroupBy"
                    [config]="vs.listGroupByConfig()" (select)="ss.updateView()" textClass="text-16-400 whitespace-nowrap"
                    [hiddenValues]="data.config['hiddenGroupValues']"></app-input-dropdown>
            </div>

        </div>
        <div class="category-item ri-px-4 ri-py-4 ri-w-full">
            <button (click)="$event.stopPropagation()">
                <app-kebab-show-menu [multiple]="true" [signal]="listShow"
                    [config]="vs.listShowConfig()" (select)="ss.updateView()" textClass="text-16-400"
                    [hiddenValues]="data.config['hiddenShowValues']"
                    [placeholder]="ss.t('common_kebabMenuViewConfiguration')"></app-kebab-show-menu>
            </button>
        </div>
    </div>
</div>
